<script lang="ts" setup>
import { computed } from 'vue';
import { AppInput, type IconProp } from '@sunlabde/m2m-library';
import i18n from '@/plugins/i18n';

const props = withDefaults(defineProps<{
	modelValue?: string;
	success?: boolean;
	loading?: boolean;
	buttonLabel?: string;
	inputLabel?: string;
	error?: string;
	icon?: IconProp;
}>(), {
	modelValue: '',
	success: false,
	loading: false,
	buttonLabel: i18n.global.t('button.redeemCouponCode'),
	inputLabel: i18n.global.t('input.yourVoucherCode'),
	error: '',
	// @ts-expect-error => IconProp type needs to be replaced with simpler prop in m2m-library. Maybe "string | string[]"
	icon: () => 'barcode-alt',
});

const emits = defineEmits<{
	(e: 'update:modelValue', value: string): void;
	(e: 'submit'): void;
}>();

const inputValue = computed({
	get() {
		return props.modelValue;
	},
	set(value: string) {
		emits('update:modelValue', value);
	},
});

const onSubmit = () => {
	inputValue.value = inputValue.value.trim();
	emits('submit');
};
</script>

<template>
	<div class="flex flex-col gap-2 desktop:gap-6 mobile:flex-row w-full">
		<div class="w-full">
			<AppInput
				v-model="inputValue"
				:disabled="success"
				:label="inputLabel"
				:error-message="error"
				:icon="icon"
				class="mb-0 w-full"
				@keypress.enter="onSubmit"
			/>
		</div>
		<div>
			<AppButton
				:is-loading="loading"
				:is-success="success"
				:color="success ? 'green' : 'gray'"
				data-cy="button_coupon_redeem"
				@click="onSubmit"
			>
				{{ buttonLabel }}
			</AppButton>
		</div>
	</div>
</template>
